import React from 'react';
import s from './PrimeUserComments.scss';
import Comments from '../../routes/primeuserarticleshow/components/common/Comments';

class PrimeUserComments extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return <Comments {...this.props} styles={s} isPrime />;
  }
}

export default PrimeUserComments;
